import 'dayjs/locale/tr';

import { ConfigProvider, ThemeConfig } from 'antd';
import trTR from 'antd/locale/tr_TR';
import dayjs from 'dayjs';
import { lazy, Suspense } from 'react';

import OfflineDetector from '@/components/OfflineDetector';
import SessionInvalidatedModal from '@/components/SessionInvalidatedModal';
import { AuthProvider } from '@/providers/auth/AuthProvider';
import Router from '@/router/Router';

// Sayfa chunk'ı (manualChunks: page_oauth) index chunk'ından STATİK import edilmez:
// Rollup'ta index -> page_oauth -> page_auth -> index döngüsü oluşur, React
// tanımlanmadan çalışır ("Cannot set properties of undefined (setting 'Children')",
// 20 Eyl 2026 production beyaz ekran). Tembel import döngüyü kırar.
const OAuthConsent = lazy(() => import('@/pages/oauth/Authorize'));

dayjs.locale('tr');

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { usePageRefreshReminder } from './hooks/usePageRefreshReminder';
import { calculateTimeUntilMidnight } from './query-hooks/useWorkDay';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      retryDelay: 2000,
      refetchInterval: () => calculateTimeUntilMidnight(),
      refetchIntervalInBackground: true
    }
  }
});

const theme: ThemeConfig = {
  token: {
    controlHeight: 38
  },
  components: {
    Segmented: {
      itemSelectedColor: '#1677ff'
    }
  }
};

function App() {
  const { refreshModal } = usePageRefreshReminder();

  // MCP OAuth consent/login ekranı: kimlik doğrulama akışından bağımsız,
  // uygulamanın auth-gated router'ından önce tek başına render edilir.
  if (typeof window !== 'undefined' && window.location.pathname === '/oauth/authorize') {
    return (
      <ConfigProvider locale={trTR} theme={theme}>
        <Suspense fallback={null}>
          <OAuthConsent />
        </Suspense>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider locale={trTR} theme={theme}>
      <QueryClientProvider client={queryClient}>
        <OfflineDetector />
        <AuthProvider>
          <Router />
        </AuthProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        {refreshModal}
        <SessionInvalidatedModal />
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
